<template>
  <div id="trace-record" class="scroll">
    <ul class="record-title">
      <li>作业</li>
			<li>人员</li>
			<li>农机</li>
      <li>时间</li>
    </ul>
    <transition-group
      class="record-view"
      name="record-value"
      tag="div">
      <ul
        class="record-value"
        v-for="item in tasks"
        :key="item.id">
        <li>{{ item.task }}</li>
        <li>{{ item.workerName }}</li>
        <li>{{ item.machineName }}</li>
        <li>{{ item.time }}</li>
      </ul>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "trace-record",
  data() {
    return {
      tasks: [],
      index: 0,
      pages: 0,
      timer: null
    }
  },
  mounted() {
    // 小于等于4条直接显示
    if (this.getPlantWork.task.length <= 4) {
      this.tasks = this.getPlantWork.task;
    } else {
      // 显示页数
      this.pages = Math.ceil(this.getPlantWork.task.length / 4);
      // 每3秒翻一次页
      this.scrollList(this.index, this.pages);
      this.timer = setInterval(() => {
        this.scrollList(this.index, this.pages);
      }, 3000);
    }
  },
	computed: {
		...mapGetters("trace", ["getPlantWork"])
	},
  methods: {
    scrollList(index, pages) {
      // 当索引大于页数时，重置回第一页
      if (index === pages) {
        this.index = 0;
        this.tasks = [];
        for (let i = 0; i < 4; i++) {
          this.tasks.push(this.getPlantWork.task[i]);
        }
      }
      else {
        this.tasks = [];
        for (let i = index * 4; (i < index * 4 + 4 && i < this.getPlantWork.task.length); i++) {
          this.tasks.push(this.getPlantWork.task[i]);
        }
        this.index++;
      }
    }
  },
  destroyed() {
    if (this.timer !== null) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style scoped>
ul {
  list-style: none;
}

#trace-record {
	/* overflow: auto; */
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.record-title {
  display: flex;
  width: 100%;
  height: 20%;
  align-items: center;
  background-color: rgba(0, 57, 101, 0.8);
  font-size: 0.5vw;
  color: #a7a7a7;
}

.record-title li {
  text-align: center;
  width: 25%;
}

li:first-child{
	width: 35% !important;
}

.record-view {
  position: relative;
  width: 100%;
  height: 80%;
  overflow: hidden;
}

.record-value {
  font-size: 0.5vw;
  width: 100%;
  height: 25%;
  display: flex;
  align-items: center;
  color: #a7a7a7;
  background-color: rgba(1, 23, 41, 0.8);
	overflow: hidden;
  transition-property: all;
  transition-duration: 1.2s;
  transition-timing-function: ease;
}

.record-value-leave {
  height: 20%;
}

.record-value-leave-to {
  height: 0%;
}

.record-value li {
  width: 25%;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
